import { defineComponent as _defineComponent } from 'vue'
import { E_CompanyLogoStatus, IPlatformCompanySettingData } from '@/api/moudules/platformCompany.types';
import { platformDataValue, platformImageUrl } from '@/view_helper/platform';
import { useFavicon, useTitle } from '@vueuse/core';
import { computed, getCurrentInstance } from 'vue';
import { useI18n } from '@/hooks/useI18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'BrowerTitle',
  setup(__props) {

const instance = getCurrentInstance()
const {
    $t,
} = useI18n()

const title = computed(() => {
    const store: IPlatformCompanySettingData = instance.proxy.$store.state['platformSetting']
    return store?.systemName || $t('common.browserDefaultTitle')
})

useTitle(title)

const favIcon = computed(() => {
    const companyLogoStatus = platformDataValue(instance.proxy, 'companyLogoStatus')
    if (companyLogoStatus === E_CompanyLogoStatus.Close) {
        return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg'/%3E`
    }
    else {
        let icon = platformImageUrl(instance.proxy, 'systemLogo', true)
        return icon
    }
})
useFavicon(favIcon)


return { __sfc: true,instance, $t, title, favIcon }
}

})